export const hizmetlerData = [
    {
        name: {
            tr: "Hava Yolu Taşımacılığı",
            en: "Air Transportation",
            de: "Lufttransport"
        },
        link: "hava-yolu-tasimaciligi",
        svg: "1",
        image: "",
        miniText: {
            tr: "Zamanın değerli olduğu gönderiler için güvenilir hava yolu taşımacılığı çözümleri sunuyoruz. Tecrübeli ekibimiz ve modern altyapımız sayesinde yükleriniz en kısa sürede ve güvenle teslim edilir.",
            en: "We offer reliable air transportation solutions for shipments where time is valuable. Thanks to our experienced team and modern infrastructure, your cargo is delivered in the shortest time and with complete safety.",
            de: "Wir bieten zuverlässige Lufttransportlösungen für Sendungen, bei denen Zeit wertvoll ist. Dank unseres erfahrenen Teams und unserer modernen Infrastruktur wird Ihre Fracht in kürzester Zeit und sicher geliefert."
        },
        text: [
            {
                title: {
                    tr: "",
                    en: "",
                    de: ""
                },
                text: {
                    tr: [
                        "Zamanın kritik olduğu iş süreçlerinde, hava yolu taşımacılığı en hızlı ve etkili çözümü sunar. Genesis Trade Lojistik olarak, global iş ortaklıklarımız ve stratejik planlama kabiliyetimiz sayesinde, yüklerinizi dünya genelinde kısa sürede ve sorunsuz bir şekilde ulaştırıyoruz."
                    ],
                    en: [
                        "In business processes where time is critical, air transportation offers the fastest and most effective solution. As Genesis Trade Logistics, we deliver your cargo worldwide in the shortest time and without any issues, thanks to our global partnerships and strategic planning capabilities."
                    ],
                    de: [
                        "In Geschäftsprozessen, in denen Zeit entscheidend ist, bietet der Lufttransport die schnellste und effektivste Lösung. Als Genesis Trade Logistics liefern wir Ihre Fracht weltweit in kürzester Zeit und ohne Probleme, dank unserer globalen Partnerschaften und strategischen Planungsfähigkeiten."
                    ]
                }
            },
            {
                title: {
                    tr: "Esneklik ve Hız",
                    en: "Flexibility and Speed",
                    de: "Flexibilität und Geschwindigkeit"
                },
                text: {
                    tr: [
                        "Uluslararası ticarette değişen ihtiyaçlara hızla uyum sağlamak için esnek çözümler üretiyoruz. Acil gönderilerinizden düzenli sevkiyatlarınıza kadar her süreçte ihtiyaçlarınıza uygun hizmet sunuyoruz. İster küçük ölçekli kargolarınız olsun, ister büyük hacimli yükleriniz, tüm gönderiler için özel taşıma seçenekleriyle çalışıyoruz."
                    ],
                    en: [
                        "We provide flexible solutions to quickly adapt to changing needs in international trade. From urgent shipments to regular deliveries, we offer services tailored to your needs. Whether your cargo is small or large-scale, we provide special transportation options for all shipments."
                    ],
                    de: [
                        "Wir bieten flexible Lösungen, um uns schnell an die sich ändernden Bedürfnisse im internationalen Handel anzupassen. Von dringenden Sendungen bis hin zu regelmäßigen Lieferungen bieten wir Dienstleistungen, die auf Ihre Bedürfnisse zugeschnitten sind. Ob Ihre Fracht klein oder groß ist, wir bieten spezielle Transportmöglichkeiten für alle Sendungen."
                    ]
                }
            },
            {
                title: {
                    tr: "Gelişmiş Teknolojik Destek",
                    en: "Advanced Technological Support",
                    de: "Fortschrittliche technologische Unterstützung"
                },
                text: {
                    tr: [
                        "Yükleme, takip ve teslimat süreçlerinde teknolojiye dayalı bir yaklaşım benimsiyoruz. Gönderilerinizin her aşamasını anlık olarak izleyebilir, detaylı bilgi alabilir ve tüm süreci dijital platformlarımız üzerinden kolayca yönetebilirsiniz."
                    ],
                    en: [
                        "We adopt a technology-driven approach in loading, tracking, and delivery processes. You can monitor every stage of your shipments in real-time, receive detailed information, and easily manage the entire process through our digital platforms."
                    ],
                    de: [
                        "Wir verfolgen einen technologiegestützten Ansatz bei Be- und Entladung, Sendungsverfolgung und Lieferung. Sie können jede Phase Ihrer Sendungen in Echtzeit überwachen, detaillierte Informationen erhalten und den gesamten Prozess einfach über unsere digitalen Plattformen verwalten."
                    ]
                }
            },
            {
                title: {
                    tr: "Global Erişim Ağı",
                    en: "Global Access Network",
                    de: "Globales Zugangsnetzwerk"
                },
                text: {
                    tr: [
                        "Geniş bir rota ağı ve uluslararası iş ortaklarımız sayesinde, gönderilerinizi dünyanın her noktasına taşıyoruz. Her biri stratejik olarak konumlandırılmış bağlantı noktalarımız, operasyonlarımızın hızını ve etkinliğini artırmamızı sağlıyor."
                    ],
                    en: [
                        "Thanks to our extensive route network and international business partners, we transport your shipments to every corner of the world. Our strategically positioned connection points increase the speed and efficiency of our operations."
                    ],
                    de: [
                        "Dank unseres umfangreichen Streckennetzes und unserer internationalen Geschäftspartner transportieren wir Ihre Sendungen in jede Ecke der Welt. Unsere strategisch positionierten Verbindungspunkte erhöhen die Geschwindigkeit und Effizienz unserer Operationen."
                    ]
                }
            },
            {
                title: {
                    tr: "Müşteriye Özel Çözümler",
                    en: "Custom Solutions for Clients",
                    de: "Kundenspezifische Lösungen"
                },
                text: {
                    tr: [
                        "Hava yolu taşımacılığında yalnızca standart bir hizmet sunmuyoruz. Her müşterimizin ihtiyaçlarına uygun çözümler geliştiriyor, gönderi sürecini detaylı bir şekilde planlıyoruz. Böylece, iş hedeflerinize ulaşmanızda güçlü bir lojistik destek sağlıyoruz."
                    ],
                    en: [
                        "We do not just offer a standard service in air transportation. We develop solutions tailored to each customer's needs and meticulously plan the shipping process. This way, we provide strong logistics support to help you achieve your business goals."
                    ],
                    de: [
                        "Wir bieten nicht nur einen Standardservice im Lufttransport. Wir entwickeln Lösungen, die auf die Bedürfnisse jedes Kunden zugeschnitten sind, und planen den Versandprozess detailliert. So bieten wir eine starke logistische Unterstützung, um Ihre Geschäftsziele zu erreichen."
                    ]
                }
            },
            {
                title: {
                    tr: "Çevreye Duyarlı Yaklaşım",
                    en: "Environmentally Conscious Approach",
                    de: "Umweltbewusster Ansatz"
                },
                text: {
                    tr: [
                        "Hava yolu taşımacılığında karbon ayak izimizi minimize etmek için çevre dostu çözümler geliştiriyoruz. Hem müşterilerimizin lojistik ihtiyaçlarını karşılıyor hem de sürdürülebilir bir ticaret anlayışıyla doğaya olan sorumluluğumuzu yerine getiriyoruz.",
                        "Genesis Trade, hava yolu taşımacılığında yalnızca hız değil, aynı zamanda güven, teknoloji ve müşteri memnuniyetini bir arada sunarak işinizi her zamankinden daha ileriye taşır."
                    ],
                    en: [
                        "We develop eco-friendly solutions to minimize our carbon footprint in air transportation. While meeting our customers' logistics needs, we also fulfill our responsibility to nature with a sustainable trade approach.",
                        "Genesis Trade not only provides speed in air transportation but also combines security, technology, and customer satisfaction to take your business further than ever before."
                    ],
                    de: [
                        "Wir entwickeln umweltfreundliche Lösungen, um unseren CO₂-Fußabdruck im Lufttransport zu minimieren. Während wir die logistischen Bedürfnisse unserer Kunden erfüllen, übernehmen wir auch mit einem nachhaltigen Handelsansatz Verantwortung für die Natur.",
                        "Genesis Trade bietet nicht nur Geschwindigkeit im Lufttransport, sondern kombiniert Sicherheit, Technologie und Kundenzufriedenheit, um Ihr Geschäft weiter voranzubringen als je zuvor."
                    ]
                }
            }
        ]
    },
    


    {
        name: {
            tr: "Kara Yolu Taşımacılığı",
            en: "Road Transportation",
            de: "Straßentransport"
        },
        link: "kara-yolu-tasimaciligi",
        svg: "4",
        image: "",
        miniText: {
            tr: "Kara taşımacılığında, Türkiye’den başta Avrupa ve Orta Doğu’ya uzanan geniş bir hizmet ağı sunuyoruz. Modern araç filomuz, yüksek donanımlı ekipmanlarımız ve deneyimli personelimizle, yüklerinizi zamanında ve sorunsuz bir şekilde ulaştırıyoruz.",
            en: "In road transportation, we offer a wide service network extending from Turkey to Europe and the Middle East. With our modern vehicle fleet, high-tech equipment, and experienced personnel, we ensure that your cargo is delivered on time and without any issues.",
            de: "Im Straßentransport bieten wir ein umfangreiches Servicenetz, das sich von der Türkei nach Europa und in den Nahen Osten erstreckt. Mit unserer modernen Fahrzeugflotte, hochmodernen Ausrüstung und erfahrenem Personal stellen wir sicher, dass Ihre Fracht pünktlich und problemlos geliefert wird."
        },
        text: [
            {
                title: {
                    tr: "",
                    en: "",
                    de: ""
                },
                text: {
                    tr: [
                        "Genesis Trade Lojistik olarak, kara yolu taşımacılığında sınırların ötesine geçerek Türkiye’den Avrupa ve Orta Doğu’ya uzanan geniş bir hizmet ağı sunuyoruz. Güvenilir ve sistematik bir altyapı ile çalışarak, müşterilerimizin lojistik ihtiyaçlarını tam zamanında karşılıyoruz."
                    ],
                    en: [
                        "As Genesis Trade Logistics, we go beyond borders in road transportation, offering a wide service network from Turkey to Europe and the Middle East. With a reliable and systematic infrastructure, we meet our customers' logistics needs right on time."
                    ],
                    de: [
                        "Als Genesis Trade Logistics überschreiten wir Grenzen im Straßentransport und bieten ein umfangreiches Servicenetz von der Türkei nach Europa und in den Nahen Osten. Mit einer zuverlässigen und systematischen Infrastruktur erfüllen wir die logistischen Bedürfnisse unserer Kunden genau zur richtigen Zeit."
                    ]
                }
            },
            {
                title: {
                    tr: "Geniş Kapsama Alanı",
                    en: "Wide Coverage Area",
                    de: "Großes Abdeckungsgebiet"
                },
                text: {
                    tr: [
                        "Stratejik olarak planlanmış rotalar ve entegre taşıma çözümleri sayesinde, ürünlerinizi Türkiye’nin her noktasından Avrupa, Orta Doğu ve komşu ülkelere ulaştırıyoruz. Çeşitli coğrafyalardaki operasyonel deneyimimiz, yüklerinizin her şartta güvenli bir şekilde teslim edilmesini sağlıyor."
                    ],
                    en: [
                        "Thanks to strategically planned routes and integrated transport solutions, we deliver your products from any point in Turkey to Europe, the Middle East, and neighboring countries. Our operational experience in various geographies ensures the safe delivery of your cargo under all conditions."
                    ],
                    de: [
                        "Dank strategisch geplanter Routen und integrierter Transportlösungen liefern wir Ihre Produkte von jedem Punkt in der Türkei nach Europa, in den Nahen Osten und in die Nachbarländer. Unsere operative Erfahrung in verschiedenen Regionen stellt die sichere Lieferung Ihrer Fracht unter allen Bedingungen sicher."
                    ]
                }
            },
            {
                title: {
                    tr: "Optimize Edilmiş Süreçler",
                    en: "Optimized Processes",
                    de: "Optimierte Prozesse"
                },
                text: {
                    tr: [
                        "Kara yolu taşımacılığında en önemli hedefimiz, zamanında teslimatla birlikte süreçlerinizi optimize etmektir. İleri planlama yöntemleri ve rotaların etkin kullanımı sayesinde, nakliye sürecindeki olası gecikmeleri minimuma indiriyoruz. Bu sayede ticari faaliyetleriniz kesintisiz bir şekilde devam eder."
                    ],
                    en: [
                        "Our main goal in road transportation is to optimize your processes while ensuring on-time delivery. Through advanced planning methods and efficient use of routes, we minimize potential delays in the transportation process. This way, your commercial activities can continue uninterrupted."
                    ],
                    de: [
                        "Unser Hauptziel im Straßentransport ist es, Ihre Prozesse zu optimieren und gleichzeitig pünktliche Lieferungen sicherzustellen. Durch fortschrittliche Planungsmethoden und die effiziente Nutzung von Routen minimieren wir mögliche Verzögerungen im Transportprozess. So können Ihre geschäftlichen Aktivitäten ununterbrochen fortgesetzt werden."
                    ]
                }
            },

            {
                title: {
                    tr: "Modern Araç Filosu ve Gelişmiş Teknoloji",
                    en: "Modern Fleet and Advanced Technology",
                    de: "Moderne Fahrzeugflotte und Fortschrittliche Technologie"
                },
                text: {
                    tr: [
                        "Farklı kapasitelere uygun, çevre dostu ve son teknolojiyle donatılmış araç filomuz, taşımacılık süreçlerinde maksimum verimlilik sunar. Ayrıca, yüklerinizi taşırken gerçek zamanlı takip sistemlerimizle gönderilerinizin her an nerede olduğunu izleyebilir, süreç üzerinde tam kontrol sağlayabilirsiniz."
                    ],
                    en: [
                        "Our fleet, equipped with cutting-edge technology and designed for various capacities, offers maximum efficiency in transportation processes. Additionally, with our real-time tracking systems, you can monitor your shipments at any moment and maintain full control over the process."
                    ],
                    de: [
                        "Unsere Fahrzeugflotte, ausgestattet mit modernster Technologie und für verschiedene Kapazitäten konzipiert, bietet maximale Effizienz in den Transportprozessen. Darüber hinaus können Sie mit unseren Echtzeit-Tracking-Systemen Ihre Sendungen jederzeit überwachen und den Prozess vollständig kontrollieren."
                    ]
                }
            },
            
            {
                title: {
                    tr: "Esnek Taşıma Seçenekleri",
                    en: "Flexible Transport Options",
                    de: "Flexible Transportmöglichkeiten"
                },
                text: {
                    tr: [
                        "Tek seferlik gönderilerden düzenli taşıma ihtiyaçlarına kadar her projeye özel çözümler üretiyoruz. Parsiyel taşıma, tam yük taşımacılığı ve özel ekipman gerektiren taşımalar gibi hizmetlerle, sektörünüzün taleplerine uygun taşıma seçenekleri sunuyoruz."
                    ],
                    en: [
                        "From one-time shipments to regular transportation needs, we offer customized solutions for every project. With services such as partial transportation, full truckload transport, and specialized equipment transport, we provide options tailored to your industry’s requirements."
                    ],
                    de: [
                        "Von einmaligen Sendungen bis hin zu regelmäßigen Transportanforderungen bieten wir maßgeschneiderte Lösungen für jedes Projekt. Mit Dienstleistungen wie Teilladungstransport, Komplettladungsverkehr und Transport mit spezieller Ausrüstung bieten wir Transportmöglichkeiten, die den Anforderungen Ihrer Branche entsprechen."
                    ]
                }
            },
            
            {
                title: {
                    tr: "Yasal ve Operasyonel Güvence",
                    en: "Legal and Operational Assurance",
                    de: "Rechtliche und Operative Sicherheit"
                },
                text: {
                    tr: [
                        "Tüm nakliye süreçlerimiz, ulusal ve uluslararası standartlara uygun şekilde gerçekleştirilir. Gümrük geçişlerinde doğru belgeler ve eksiksiz işlemlerle zaman kaybını önlüyoruz. Yasal süreçlerdeki titizliğimiz, gönderilerinizin sorunsuz bir şekilde ulaşmasını garantiler."
                    ],
                    en: [
                        "All our transportation processes are carried out in compliance with national and international standards. We prevent time loss at customs by ensuring accurate documentation and complete procedures. Our meticulous approach to legal processes guarantees that your shipments arrive smoothly."
                    ],
                    de: [
                        "Alle unsere Transportprozesse werden gemäß nationalen und internationalen Standards durchgeführt. Wir vermeiden Zeitverluste beim Zoll durch korrekte Dokumentation und vollständige Verfahren. Unsere sorgfältige Vorgehensweise bei rechtlichen Prozessen garantiert, dass Ihre Sendungen reibungslos ankommen."
                    ]
                }
            },
            
            {
                title: {
                    tr: "Sürdürülebilirlik Odaklı Yaklaşım",
                    en: "Sustainability-Focused Approach",
                    de: "Nachhaltigkeitsorientierter Ansatz"
                },
                text: {
                    tr: [
                        "Kara yolu taşımacılığında sadece performansı değil, çevresel etkileri de göz önünde bulunduruyoruz. Daha az yakıt tüketen araçlar ve optimize edilmiş rotalar sayesinde karbon salınımını azaltarak sürdürülebilir bir lojistik anlayışı benimsiyoruz.",
                        "Genesis Trade, kara yolu taşımacılığında hız, etkinlik ve yenilikçi çözümlerle işinizin büyümesine katkı sağlar. Uzun mesafelerde bile taşımacılığın en güvenilir yolu olmaya devam ediyoruz."
                    ],
                    en: [
                        "In road transportation, we consider not only performance but also environmental impact. By using fuel-efficient vehicles and optimized routes, we adopt a sustainable logistics approach by reducing carbon emissions.",
                        "Genesis Trade contributes to your business growth with speed, efficiency, and innovative solutions in road transportation. We continue to be the most reliable transportation option even over long distances."
                    ],
                    de: [
                        "Im Straßentransport berücksichtigen wir nicht nur die Leistung, sondern auch die Umweltbelastung. Durch den Einsatz kraftstoffsparender Fahrzeuge und optimierter Routen verfolgen wir einen nachhaltigen Logistikansatz, indem wir die CO2-Emissionen reduzieren.",
                        "Genesis Trade trägt mit Schnelligkeit, Effizienz und innovativen Lösungen im Straßentransport zum Wachstum Ihres Unternehmens bei. Selbst über lange Distanzen bleiben wir die zuverlässigste Transportmöglichkeit."
                    ]
                }
            }
            




        ]
    },
    


    {
        name: {
            tr: "Deniz Yolu Taşımacılığı",
            en: "Sea Transportation",
            de: "Seetransport"
        },
        link: "deniz-yolu-tasimaciligi",
        svg: "2",
        image: "",
        miniText: {
            tr: "Genesis Trade, deniz yolu taşımacılığında hem rekabet avantajı sağlayan ekonomik çözümler hem de müşteri odaklı bir hizmet anlayışı sunar. Uluslararası ticaretteki tüm taşıma ihtiyaçlarınıza cevap verebilecek kapasitemizle, yüklerinizin dünya çapında sorunsuz bir şekilde taşınmasını sağlıyoruz.",
            en: "Genesis Trade offers both cost-effective solutions that provide a competitive advantage and a customer-focused service approach in sea transportation. With our capacity to meet all your transportation needs in international trade, we ensure that your cargo is transported seamlessly worldwide.",
            de: "Genesis Trade bietet im Seetransport sowohl kosteneffiziente Lösungen mit Wettbewerbsvorteil als auch einen kundenorientierten Serviceansatz. Mit unserer Kapazität, alle Ihre Transportbedürfnisse im internationalen Handel zu erfüllen, sorgen wir dafür, dass Ihre Fracht weltweit reibungslos transportiert wird."
        },
        text: [
            {
                title: {
                    tr: "",
                    en: "",
                    de: ""
                },
                text: {
                    tr: [
                        "Deniz yolu taşımacılığı, uluslararası ticaretin en ekonomik ve çevre dostu seçeneklerinden biridir. Genesis Trade Lojistik olarak, küresel ölçekte geniş bağlantı ağımız ve modern lojistik altyapımızla, müşterilerimizin yüklerini sorunsuz bir şekilde limandan limana taşıyoruz. Her proje için özel olarak planlanan çözümlerimizle, deniz yolu taşımacılığını en verimli hale getiriyoruz."
                    ],
                    en: [
                        "Sea transportation is one of the most cost-effective and environmentally friendly options in international trade. As Genesis Trade Logistics, we seamlessly transport our customers' cargo from port to port with our extensive global network and modern logistics infrastructure. With solutions tailored to each project, we make sea transportation as efficient as possible."
                    ],
                    de: [
                        "Der Seetransport ist eine der wirtschaftlichsten und umweltfreundlichsten Optionen im internationalen Handel. Als Genesis Trade Logistics transportieren wir die Fracht unserer Kunden nahtlos von Hafen zu Hafen mit unserem umfangreichen globalen Netzwerk und unserer modernen Logistikinfrastruktur. Mit individuell geplanten Lösungen machen wir den Seetransport so effizient wie möglich."
                    ]
                }
            },
            {
                title: {
                    tr: "Kapsamlı Rota Ağı ve Stratejik İş Ortaklıkları",
                    en: "Extensive Route Network and Strategic Partnerships",
                    de: "Umfassendes Routennetzwerk und strategische Partnerschaften"
                },
                text: {
                    tr: [
                        "Dünyanın dört bir yanındaki limanlarla olan güçlü bağlantılarımız ve uluslararası iş ortaklıklarımız, yüklerinizin istediğiniz noktaya zamanında ulaşmasını sağlar. Her liman için özelleştirilmiş taşıma stratejilerimiz, sürecin hızını ve verimliliğini artırır."
                    ],
                    en: [
                        "Our strong connections with ports worldwide and international business partnerships ensure that your cargo reaches its destination on time. Our customized transportation strategies for each port increase the speed and efficiency of the process."
                    ],
                    de: [
                        "Unsere starken Verbindungen zu Häfen weltweit und internationalen Geschäftspartnern stellen sicher, dass Ihre Fracht pünktlich ihr Ziel erreicht. Unsere maßgeschneiderten Transportstrategien für jeden Hafen erhöhen die Geschwindigkeit und Effizienz des Prozesses."
                    ]
                }
            },
            {
                title: {
                    tr: "Esnek Yük Taşıma Seçenekleri",
                    en: "Flexible Cargo Transport Options",
                    de: "Flexible Frachttransportoptionen"
                },
                text: {
                    tr: [
                        "Tam konteyner yüklemeleri (FCL) veya parsiyel taşımalar (LCL) dahil olmak üzere farklı hacimlere ve yük türlerine uygun çözümler sunuyoruz. Ürünlerinizin niteliğine göre en doğru taşıma yöntemini seçerek, ihtiyaçlarınıza odaklanıyoruz."
                    ],
                    en: [
                        "We offer solutions suitable for different volumes and cargo types, including full container load (FCL) and less than container load (LCL) shipments. By selecting the most appropriate transportation method based on the nature of your products, we focus on your needs."
                    ],
                    de: [
                        "Wir bieten Lösungen für verschiedene Volumen und Frachtarten, einschließlich Vollcontainerladungen (FCL) und Stückguttransporte (LCL). Durch die Wahl der besten Transportmethode basierend auf der Art Ihrer Produkte konzentrieren wir uns auf Ihre Bedürfnisse."
                    ]
                }
            },
            {
                title: {
                    tr: "Modern Teknolojik Destek",
                    en: "Modern Technological Support",
                    de: "Moderne technologische Unterstützung"
                },
                text: {
                    tr: [
                        "Deniz yolu taşımacılığında teknolojinin gücünden yararlanıyoruz. Yüklerinizi takip etmenizi sağlayan dijital izleme sistemlerimiz, süreçlerin şeffaf ve güvenilir bir şekilde yönetilmesine olanak tanır. Bu sayede gönderilerinizin nerede olduğunu her an bilirsiniz."
                    ],
                    en: [
                        "We leverage the power of technology in sea transportation. Our digital tracking systems allow you to monitor your cargo, ensuring transparency and reliability throughout the process. This way, you always know where your shipments are."
                    ],
                    de: [
                        "Wir nutzen die Kraft der Technologie im Seetransport. Unsere digitalen Tracking-Systeme ermöglichen es Ihnen, Ihre Fracht zu überwachen und gewährleisten Transparenz und Zuverlässigkeit während des gesamten Prozesses. So wissen Sie jederzeit, wo sich Ihre Sendungen befinden."
                    ]
                }
            },
            {
                title: {
                    tr: "Planlı ve Optimize Edilmiş Süreçler",
                    en: "Planned and Optimized Processes",
                    de: "Geplante und Optimierte Prozesse"
                },
                text: {
                    tr: [
                        "Nakliye sürecinin her aşamasını özenle planlıyoruz. Operasyonel süreçlerdeki öngörülerimiz, olası gecikmelerin ve maliyet artışlarının önüne geçer. Sizin için ekonomik, hızlı ve sorunsuz bir taşımacılık deneyimi sağlıyoruz."
                    ],
                    en: [
                        "We carefully plan every stage of the transportation process. Our insights into operational processes prevent possible delays and cost increases. We provide you with an economical, fast, and seamless transportation experience."
                    ],
                    de: [
                        "Wir planen sorgfältig jede Phase des Transportprozesses. Unsere Einblicke in betriebliche Abläufe verhindern mögliche Verzögerungen und Kostensteigerungen. Wir bieten Ihnen eine wirtschaftliche, schnelle und reibungslose Transporterfahrung."
                    ]
                }
            },
            
            
            {
                title: {
                    tr: "Sürdürülebilir Taşımacılık Anlayışı",
                    en: "Sustainable Transportation Approach",
                    de: "Nachhaltiger Transportansatz"
                },
                text: {
                    tr: [
                        "Çevreye duyarlı yaklaşımlarımız, deniz yolu taşımacılığında da ön plandadır. Daha az karbon salınımı üreten taşıma yöntemleriyle, ticaretinizi sürdürülebilir bir zemine taşımayı amaçlıyoruz."
                    ],
                    en: [
                        "Our environmentally conscious approach is also at the forefront of sea transportation. We aim to make your trade more sustainable by using transportation methods that produce lower carbon emissions."
                    ],
                    de: [
                        "Unser umweltbewusster Ansatz steht auch im Seetransport im Vordergrund. Mit Transportmethoden, die geringere CO₂-Emissionen verursachen, wollen wir Ihren Handel nachhaltiger gestalten."
                    ]
                }
            },
            {
                title: {
                    tr: "Ürün Güvenliği ve Hassasiyet",
                    en: "Product Safety and Sensitivity",
                    de: "Produktsicherheit und Sensibilität"
                },
                text: {
                    tr: [
                        "Deniz yolu taşımacılığında yüklerinizin güvenliğini sağlamak için uluslararası standartlara uygun taşıma yöntemleri uyguluyoruz. Ürünlerinizi, hasar riski en düşük şekilde taşıyarak teslim ediyoruz.",
                        "Genesis Trade, deniz yolu taşımacılığında hem rekabet avantajı sağlayan ekonomik çözümler hem de müşteri odaklı bir hizmet anlayışı sunar. Uluslararası ticaretteki tüm taşıma ihtiyaçlarınıza cevap verebilecek kapasitemizle, yüklerinizin dünya çapında sorunsuz bir şekilde taşınmasını sağlıyoruz."
                    ],
                    en: [
                        "We apply transportation methods that comply with international standards to ensure the safety of your cargo in sea transportation. We deliver your products with the lowest risk of damage.",
                        "Genesis Trade offers cost-effective solutions that provide a competitive advantage and a customer-focused service approach in sea transportation, ensuring that your cargo is transported seamlessly worldwide."
                    ],
                    de: [
                        "Wir setzen Transportmethoden ein, die internationalen Standards entsprechen, um die Sicherheit Ihrer Fracht im Seetransport zu gewährleisten. Wir liefern Ihre Produkte mit minimalem Schadensrisiko.",
                        "Genesis Trade bietet kosteneffiziente Lösungen mit Wettbewerbsvorteil und einen kundenorientierten Serviceansatz im Seetransport, um sicherzustellen, dass Ihre Fracht weltweit reibungslos transportiert wird."
                    ]
                }
            }
        ]
    },
    
    {
        name: {
            tr: "İntermodal Taşımacılık",
            en: "Intermodal Transportation",
            de: "Intermodaler Transportdienst"
        },
        link: "intermodal-tasimacilik-hizmeti",
        svg: "6",
        image: "",
        miniText: {
            tr: "Lojistik sektöründe güvenilir çözüm ortağınız olarak, yüklerinizi zamanında, güvenle ve dünya çapında her noktaya ulaştırıyoruz. Farklı ulaşım modlarını bir araya getirerek, yüklerinizi daha hızlı, ekonomik ve çevreci şekilde taşıyoruz.",
            en: "As your reliable solution partner in the logistics sector, we deliver your cargo on time, safely, and to every point worldwide. By combining different transportation modes, we transport your cargo faster, more economically, and in an environmentally friendly manner.",
            de: "Als Ihr zuverlässiger Lösungspartner in der Logistikbranche liefern wir Ihre Fracht pünktlich, sicher und weltweit an jeden Ort. Durch die Kombination verschiedener Transportarten transportieren wir Ihre Fracht schneller, wirtschaftlicher und umweltfreundlicher."
        },
        text: [
            {
                title: {
                    tr: "",
                    en: "",
                    de: ""
                },
                text: {
                    tr: [
                        "Lojistik sektöründe güvenilir çözüm ortağınız olarak, yüklerinizi zamanında, güvenle ve dünya çapında her noktaya ulaştırıyoruz. Farklı ulaşım modlarını bir araya getirerek, yüklerinizi daha hızlı, ekonomik ve çevreci şekilde taşıyoruz. Karayolu, demiryolu, denizyolu ve havayolu gibi farklı taşıma yöntemlerini entegre ederek, lojistik süreçlerinizi optimize ediyor ve operasyonel maliyetlerinizi minimize ediyoruz."
                    ],
                    en: [
                        "As your reliable solution partner in the logistics sector, we deliver your cargo on time, safely, and to every point worldwide. By combining different transportation modes, we transport your cargo faster, more economically, and in an environmentally friendly manner. By integrating various transport methods such as road, rail, sea, and air, we optimize your logistics processes and minimize operational costs."
                    ],
                    de: [
                        "Als Ihr zuverlässiger Lösungspartner in der Logistikbranche liefern wir Ihre Fracht pünktlich, sicher und weltweit an jeden Ort. Durch die Kombination verschiedener Transportarten transportieren wir Ihre Fracht schneller, wirtschaftlicher und umweltfreundlicher. Durch die Integration verschiedener Transportmethoden wie Straße, Schiene, See und Luft optimieren wir Ihre Logistikprozesse und minimieren die Betriebskosten."
                    ]
                }
            },
            {
                title: {
                    tr: "Maliyet Etkinliği",
                    en: "Cost Efficiency",
                    de: "Kosteneffizienz"
                },
                text: {
                    tr: [
                        "Alternatif taşıma modları kullanarak lojistik giderlerinizi azaltıyoruz."
                    ],
                    en: [
                        "We reduce your logistics costs by utilizing alternative transportation modes."
                    ],
                    de: [
                        "Wir senken Ihre Logistikkosten durch den Einsatz alternativer Transportarten."
                    ]
                }
            },
            {
                title: {
                    tr: "Çevre Dostu Yaklaşım",
                    en: "Eco-Friendly Approach",
                    de: "Umweltfreundlicher Ansatz"
                },
                text: {
                    tr: [
                        "Karbon salınımını azaltarak çevreye duyarlı bir taşıma süreci sunuyoruz."
                    ],
                    en: [
                        "We offer an environmentally friendly transportation process by reducing carbon emissions."
                    ],
                    de: [
                        "Wir bieten einen umweltfreundlichen Transportprozess, indem wir die CO₂-Emissionen reduzieren."
                    ]
                }
            },
            {
                title: {
                    tr: "Hız ve Verimlilik",
                    en: "Speed and Efficiency",
                    de: "Geschwindigkeit und Effizienz"
                },
                text: {
                    tr: [
                        "En hızlı ve güvenli taşıma kombinasyonlarıyla teslimat sürelerinizi kısaltıyoruz."
                    ],
                    en: [
                        "We shorten your delivery times with the fastest and safest transportation combinations."
                    ],
                    de: [
                        "Wir verkürzen Ihre Lieferzeiten mit den schnellsten und sichersten Transportkombinationen."
                    ]
                }
            },
            {
                title: {
                    tr: "Güvenilirlik",
                    en: "Reliability",
                    de: "Zuverlässigkeit"
                },
                text: {
                    tr: [
                        "Yüklerinizin daha az elleçlenmesini sağlayarak hasar ve kayıp risklerini en aza indiriyoruz."
                    ],
                    en: [
                        "We minimize damage and loss risks by reducing the handling of your cargo."
                    ],
                    de: [
                        "Wir minimieren das Risiko von Schäden und Verlusten, indem wir die Handhabung Ihrer Fracht reduzieren."
                    ]
                }
            },
            {
                title: {
                    tr: "Güvenilirlik",
                    en: "Reliability",
                    de: "Zuverlässigkeit"
                },
                text: {
                    tr: [
                        "Lojistik süreçlerinizi ihtiyaçlarınıza göre şekillendiriyor ve değişken pazar koşullarına uyum sağlıyoruz."
                    ],
                    en: [
                        "We tailor your logistics processes to your needs and adapt to changing market conditions."
                    ],
                    de: [
                        "Wir passen Ihre Logistikprozesse an Ihre Bedürfnisse an und reagieren auf sich ändernde Marktbedingungen."
                    ]
                }
            },
            {
                title: {
                    tr: "Kimler Faydalanabilir?",
                    en: "Who Can Benefit?",
                    de: "Wer kann profitieren?"
                },
                text: {
                    tr: [
                        "İntermodal taşımacılık, uluslararası ticaret yapan firmalar, büyük ölçekli üreticiler, lojistik şirketleri ve çevreye duyarlı taşımacılık çözümleri arayan işletmeler için idealdir. Ağır yük taşımacılığı, büyük hacimli lojistik operasyonları ve uzun mesafeli taşımacılık süreçlerinde sunduğumuz avantajlardan yararlanabilirsiniz."
                    ],
                    en: [
                        "Intermodal transportation is ideal for companies engaged in international trade, large-scale manufacturers, logistics companies, and businesses seeking environmentally friendly transportation solutions. You can benefit from our advantages in heavy cargo transportation, large-scale logistics operations, and long-distance transport processes."
                    ],
                    de: [
                        "Der intermodale Transport ist ideal für Unternehmen, die internationalen Handel betreiben, für Großproduzenten, Logistikunternehmen und Unternehmen, die nach umweltfreundlichen Transportlösungen suchen. Sie können von unseren Vorteilen im Schwerlasttransport, bei groß angelegten Logistikoperationen und bei Langstreckentransporten profitieren."
                    ]
                }
            }
        ]
    },





    {
        name: {
            tr: "Gümrükleme Hizmetleri",
            en: "Customs Clearance Services",
            de: "Zollabfertigungsdienste"
        },
        link: "gumrukleme-hizmetleri",
        svg: "3",
        image: "",
        miniText: {
            tr: "Genesis Trade Lojistik olarak, bu süreci sizin için kolaylaştırmak ve hızlandırmak adına kapsamlı ve profesyonel çözümler sunuyoruz. Doğru belgeler, hızlı işlem süreçleri ve yasal prosedürlere tam uyum ile ticari faaliyetlerinize kesintisiz destek sağlıyoruz.",
            en: "As Genesis Trade Logistics, we offer comprehensive and professional solutions to simplify and accelerate this process for you. With accurate documentation, fast processing times, and full compliance with legal procedures, we provide uninterrupted support for your commercial activities.",
            de: "Als Genesis Trade Logistics bieten wir umfassende und professionelle Lösungen, um diesen Prozess für Sie zu erleichtern und zu beschleunigen. Mit korrekten Dokumenten, schnellen Bearbeitungszeiten und vollständiger Einhaltung der gesetzlichen Vorschriften unterstützen wir Ihre Geschäftsaktivitäten nahtlos."
        },
        text: [
            {
                title: {
                    tr: "",
                    en: "",
                    de: ""
                },
                text: {
                    tr: [
                        "Gümrükleme, uluslararası taşımacılığın en kritik aşamalarından biridir. Genesis Trade Lojistik olarak, bu süreci sizin için kolaylaştırmak ve hızlandırmak adına kapsamlı ve profesyonel çözümler sunuyoruz. Doğru belgeler, hızlı işlem süreçleri ve yasal prosedürlere tam uyum ile ticari faaliyetlerinize kesintisiz destek sağlıyoruz."
                    ],
                    en: [
                        "Customs clearance is one of the most critical stages of international transportation. As Genesis Trade Logistics, we provide comprehensive and professional solutions to simplify and speed up this process for you. With accurate documentation, fast processing times, and full compliance with legal procedures, we ensure uninterrupted support for your commercial activities."
                    ],
                    de: [
                        "Die Zollabfertigung ist eine der kritischsten Phasen im internationalen Transport. Als Genesis Trade Logistics bieten wir umfassende und professionelle Lösungen, um diesen Prozess für Sie zu vereinfachen und zu beschleunigen. Mit korrekten Dokumenten, schnellen Bearbeitungszeiten und vollständiger Einhaltung der gesetzlichen Vorschriften stellen wir eine nahtlose Unterstützung Ihrer Geschäftstätigkeit sicher."
                    ]
                }
            },
            {
                title: {
                    tr: "Yasal Süreçlere Tam Hakimiyet",
                    en: "Full Mastery of Legal Processes",
                    de: "Umfassende Kenntnis der gesetzlichen Prozesse"
                },
                text: {
                    tr: [
                        "Ulusal ve uluslararası gümrük mevzuatlarını yakından takip ederek, süreçlerin sorunsuz ilerlemesini sağlıyoruz. İthalat ve ihracat işlemlerinizde gerekli olan tüm belge ve izinlerin doğru ve eksiksiz bir şekilde hazırlanmasını garanti ediyoruz."
                    ],
                    en: [
                        "We closely follow national and international customs regulations to ensure smooth processes. We guarantee that all necessary documents and permits for your import and export operations are prepared accurately and completely."
                    ],
                    de: [
                        "Wir verfolgen die nationalen und internationalen Zollvorschriften genau, um einen reibungslosen Ablauf zu gewährleisten. Wir stellen sicher, dass alle erforderlichen Dokumente und Genehmigungen für Ihre Import- und Exportgeschäfte korrekt und vollständig vorbereitet werden."
                    ]
                }
            },
            {
                title: {
                    tr: "Operasyonel Hız ve Etkinlik",
                    en: "Operational Speed and Efficiency",
                    de: "Betriebliche Geschwindigkeit und Effizienz"
                },
                text: {
                    tr: [
                        "Gümrükleme işlemleri genellikle zaman kaybına neden olabilir. Bu noktada Genesis Trade, operasyonel süreçleri önceden planlayarak, bekleme sürelerini minimuma indirir. İşlemleri hızlı ve etkin bir şekilde tamamlayarak ticari faaliyetlerinizin aksamadan devam etmesini sağlıyoruz."
                    ],
                    en: [
                        "Customs clearance procedures can often lead to time losses. At this point, Genesis Trade minimizes waiting times by planning operational processes in advance. We complete procedures quickly and efficiently to ensure your commercial activities continue without disruption."
                    ],
                    de: [
                        "Zollabfertigungsverfahren können oft zu Zeitverlusten führen. An diesem Punkt minimiert Genesis Trade die Wartezeiten, indem es die operativen Prozesse im Voraus plant. Wir erledigen die Verfahren schnell und effizient, damit Ihre Geschäftstätigkeit reibungslos fortgesetzt werden kann."
                    ]
                }
            },
            {
                title: {
                    tr: "Müşteriye Özel Çözümler",
                    en: "Customized Solutions for Clients",
                    de: "Maßgeschneiderte Lösungen für Kunden"
                },
                text: {
                    tr: [
                        "Her gönderi ve iş kolunun farklı ihtiyaçları olduğunu biliyoruz. Gümrükleme hizmetlerimizi, sektörel taleplerinize ve yüklerinizin özelliklerine göre özelleştiriyoruz. Böylece lojistik süreçlerinizin her aşamasında size en uygun çözümleri sunuyoruz."
                    ],
                    en: [
                        "We know that each shipment and industry has different requirements. We customize our customs clearance services according to your sectoral demands and the characteristics of your cargo. This way, we provide the most suitable solutions for you at every stage of the logistics process."
                    ],
                    de: [
                        "Wir wissen, dass jede Sendung und Branche unterschiedliche Anforderungen hat. Wir passen unsere Zollabfertigungsdienste an Ihre branchenspezifischen Anforderungen und die Eigenschaften Ihrer Fracht an. So bieten wir Ihnen in jeder Phase des Logistikprozesses die besten Lösungen."
                    ]
                }
            },



            {
                title: {
                    tr: "Hata Payını Azaltan Titiz Çalışma",
                    en: "Meticulous Work that Reduces Margin of Error",
                    de: "Sorgfältige Arbeit zur Reduzierung des Fehlermargins"
                },
                text: {
                    tr: [
                        "Eksik veya hatalı belgeler, taşımacılık süreçlerinde ciddi aksamalara neden olabilir. Bu durumun önüne geçmek için tüm belgeleri detaylı bir şekilde inceliyor ve doğru bilgilerle süreci yönetiyoruz. Belgelerin eksiksiz hazırlanması sayesinde, yasal prosedürleri güvence altına alıyoruz."
                    ],
                    en: [
                        "Missing or incorrect documents can cause serious disruptions in transportation processes. To prevent this, we carefully review all documents and manage the process with accurate information. By ensuring that the documents are fully prepared, we secure legal procedures."
                    ],
                    de: [
                        "Fehlende oder fehlerhafte Dokumente können schwerwiegende Störungen im Transportprozess verursachen. Um dies zu verhindern, überprüfen wir alle Dokumente sorgfältig und verwalten den Prozess mit genauen Informationen. Durch die vollständige Vorbereitung der Dokumente sichern wir die gesetzlichen Verfahren."
                    ]
                }
            },




            {
                title: {
                    tr: "Dijital Takip ve Raporlama",
                    en: "Digital Tracking and Reporting",
                    de: "Digitale Verfolgung und Berichterstattung"
                },
                text: {
                    tr: [
                        "Gümrükleme sürecinin her aşamasını dijital sistemlerimizle takip edebilir, gönderilerinizin durumuna ilişkin düzenli raporlamalar alabilirsiniz. Şeffaf süreç yönetimimiz, lojistik operasyonlarınız üzerinde tam kontrol sağlamanıza yardımcı olur."
                    ],
                    en: [
                        "You can track every stage of the customs clearance process through our digital systems and receive regular reports on the status of your shipments. Our transparent process management helps you maintain full control over your logistics operations."
                    ],
                    de: [
                        "Sie können jede Phase des Zollabfertigungsprozesses über unsere digitalen Systeme verfolgen und regelmäßige Berichte über den Status Ihrer Sendungen erhalten. Unser transparentes Prozessmanagement hilft Ihnen, die volle Kontrolle über Ihre Logistikabläufe zu behalten."
                    ]
                }
            },
            {
                title: {
                    tr: "Yüklerinize Özel Çözümler",
                    en: "Tailored Solutions for Your Cargo",
                    de: "Individuelle Lösungen für Ihre Fracht"
                },
                text: {
                    tr: [
                        "Gümrükleme hizmetlerimiz yalnızca belge hazırlamakla sınırlı değil; aynı zamanda hassas veya özel taşıma gerektiren yükler için ekstra prosedürleri de yönetiyoruz. Böylece her tür gönderiniz için doğru çözümleri sunuyoruz.",
                        "Genesis Trade Lojistik, gümrükleme hizmetlerinde hız, doğruluk ve yasal uyum ile işinizi bir adım öne taşır. Tüm süreçlerimizi güvenilir bir planlama ile yöneterek, uluslararası taşımacılığınızı sorunsuz bir şekilde tamamlamanızı sağlıyoruz."
                    ],
                    en: [
                        "Our customs clearance services go beyond document preparation; we also manage additional procedures for cargo that requires sensitive or special handling. Thus, we offer the right solutions for all types of shipments.",
                        "Genesis Trade Logistics takes your business a step further with speed, accuracy, and legal compliance in customs clearance services. We manage all our processes with reliable planning, ensuring seamless international transportation."
                    ],
                    de: [
                        "Unsere Zollabfertigungsdienste beschränken sich nicht nur auf die Dokumentenerstellung; wir verwalten auch zusätzliche Verfahren für Fracht, die eine besondere oder empfindliche Handhabung erfordert.",
                        "Genesis Trade Logistics bringt Ihr Geschäft mit Schnelligkeit, Genauigkeit und gesetzlicher Konformität in der Zollabfertigung voran."
                    ]
                }
            }
        ]
    },












    



 
    

]